const isAdmin = (meta) => meta.dispatch(isAdminGuardAction(meta));

const isAdminGuardAction = (to) => (_dispatch, getState) => {

	const state = getState()

	if (state.auth.userType === 'admin' || state.auth.user?.role?.some((role) => role.name === "Admin User")) {
		return null
	}

	return '/'
}

export { isAdmin };
